import { createSlice } from "@reduxjs/toolkit";

const initialChartIds = ["vPerformChart1", "vPerformChart2", "vPerformChart3", "vPerformChart4", "vPerformChart5", "vPerformChart6", "vPerformChart7"]; 

const toggleTableSlice = createSlice({
    name: "toggleTable",
    initialState: {
        chartToggles: initialChartIds.reduce((acc, chartId) => {
            acc[chartId] = false;
            return acc;
        }, {}),
    },
    reducers: {
        toggleTable: (state, action) => {
            const { chartId, isTableVisible } = action.payload;
            state.chartToggles[chartId] = isTableVisible;
        },
    },
});

export const { toggleTable } = toggleTableSlice.actions;

export const selectTable = (chartId) => (state) => state.toggleTable.chartToggles[chartId] || false;

export default toggleTableSlice.reducer;
